module.exports = __webpack_public_path__ + "media/images/emblems/Bissone-coat_of_arms-27c7881d0c297f40f732d7cf583eb56d.svg";